import { matchPath } from 'react-router-dom';
import { AppRoutes } from '@/utils/constants';

export const matchAppRoute = (pathname: string): AppRoutes | null =>
  Object.values(AppRoutes).find(route => matchPath(route, pathname) !== null) ?? null;
